
import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'organization' | 'restaurant' | 'localBusiness';
  data: any;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    script.id = `schema-${type}`;
    
    // Remove existing schema if present
    const existing = document.getElementById(`schema-${type}`);
    if (existing) {
      existing.remove();
    }
    
    document.head.appendChild(script);
    
    return () => {
      const scriptElement = document.getElementById(`schema-${type}`);
      if (scriptElement) {
        scriptElement.remove();
      }
    };
  }, [type, data]);

  return null;
}
